module.exports = __webpack_public_path__ + "img/txt_info4.89bfa237.png";